import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

import {
    accountLayoutContainer,
    accountLayout,
    accountLayoutDashboard,
    accountNav,
    brand,
    brandLogo,
    navLinks,
    loginButton,
    menuToggle,
    mobileMenu,
    mobileMenuOpen,
    accountMenuButton,
    sidebar,
    sidebarOpened,
    content,
    menuShown,
    starterProfileLayout,
} from "./account-layout.module.scss";

import MainLayout, { IMainLayoutProps } from "./main-layout";
import SidePanel from "../components/molecules/side-panel";
import { useLocation } from "@reach/router";
import Link from "../components/atoms/link";
import logoFull from "../assets/images/logo_full.png";
import useUser from "../apps/auth/hooks/use-user";

export interface IAccountLayoutProps extends IMainLayoutProps {
    contentClassName?: string;
}

const navItems = [
    { label: "O Mnie", to: "/o-nas/" },
    { label: "Blog", to: "/blog/" },
    { label: "Kontakt", to: "/kontakt/" },
];

export default function AccountLayout({
    children,
    contentClassName = "",
    SEOProps,
}: IAccountLayoutProps) {
    const [userMenuShow, setUserMenuShow] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [sideBarVisible, setSideBarVisible] = useState(true);
    const location = useLocation();
    const { logOut } = useUser();
    const isStarterProfile = location.pathname.includes("/profil-startowy");


    const handleUserMenuClose = () => {
        setUserMenuShow(!userMenuShow);
    };

    const handleMobileLogout = () => {
        setIsMenuOpen(false);
        logOut();
    };

    useEffect(() => {
        console.log("location: " + location.pathname);
        if (
            location.pathname.includes("/pytanie") ||
            location.pathname.includes("/profil-startowy")
        ) {
            setSideBarVisible(false);
        }
        else {
            setSideBarVisible(true);
        }
        // setUserMenuShow(false);
        setIsMenuOpen(false);
    }, [location.pathname]);

    return (
        <MainLayout
            containerClassName={accountLayoutContainer}
            className={`${accountLayout} ${accountLayoutDashboard} ${
                isStarterProfile ? starterProfileLayout : ""
            }`}
            HeaderComponent={null}
            overflow={userMenuShow}
            SEOProps={SEOProps}
        >
            {userMenuShow && (
                <Helmet>
                    <body className={menuShown} />
                </Helmet>
            )}
            <nav className={accountNav} aria-label="Główna nawigacja">
                <Link to="/" className={brand}>
                    <img
                        src={logoFull}
                        alt="Fashion Fairy Virtual Stylist"
                        className={brandLogo}
                    />
                </Link>
                <div className={navLinks}>
                    {navItems.map(item => (
                        <Link key={item.to} to={item.to}>
                            {item.label}
                        </Link>
                    ))}
                </div>
                <Link to="/konto/panel/" className={loginButton} noPrefetch>
                    Twoje konto
                </Link>
                <button
                    className={accountMenuButton}
                    type="button"
                    onClick={handleUserMenuClose}
                >
                    Menu konta
                </button>
                <button
                    className={menuToggle}
                    type="button"
                    aria-label={isMenuOpen ? "Zamknij menu" : "Otwórz menu"}
                    aria-expanded={isMenuOpen}
                    aria-controls="account-mobile-menu"
                    onClick={() => setIsMenuOpen(isOpen => !isOpen)}
                >
                    <span />
                    <span />
                    <span />
                </button>
                <div
                    id="account-mobile-menu"
                    className={`${mobileMenu} ${isMenuOpen ? mobileMenuOpen : ""}`}
                >
                    {navItems.map(item => (
                        <Link key={item.to} to={item.to}>
                            {item.label}
                        </Link>
                    ))}
                    <Link to="/konto/panel/" noPrefetch>Twoje konto</Link>
                    <button type="button" onClick={handleMobileLogout}>
                        Wyloguj się
                    </button>
                </div>
            </nav>
            {sideBarVisible && <SidePanel
                className={`${sidebar} ${userMenuShow ? sidebarOpened : ""}`}
                onClose={handleUserMenuClose}
            />}
            <div className={`${content} ${contentClassName}`}>{children}</div>
        </MainLayout>
    );
}